export const APPEALS_WIDGET_OPEN_EVENT = 'kiuf:appeals-widget-open';
